import * as React from 'react'

import { Fields } from 'embed/constants/fields'
import { Product } from 'even-ts-static'

import { ApplicationField } from 'embed/components/ApplicationField/container'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { ApplicationStep } from 'embed/constants'
import { StepbystepCreditApplicationWrapper } from '../Wrapper'

export interface Props {
  directReferral: boolean
  dispatchReturnToOriginalStep: () => void
  onBack: () => void
  onContinue: () => void
  onEnter?: () => void
  stepByStepApplicationStepIsValid: boolean
  stepByStepApplicationStep: ApplicationStep | undefined
  currentStep: number
  totalNumberOfSteps: number
}

export const StepbystepApplicationStepAnnualIncome: React.SFC<Props> = (props) => (
  <StepbystepCreditApplicationWrapper {...props}>
    <StepTitle>What's your income?</StepTitle>
    <ApplicationField
      product={Product.CreditCard}
      field={Fields.AnnualIncomeCredit}
      forceFocus={true}
      onEnter={props.onEnter}
    />
  </StepbystepCreditApplicationWrapper>
)
